import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0311fdee")

_pushScopeId("data-v-0311fdee")
const _hoisted_1 = { class: "editable-input" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("input", {
      class: "input-content",
      value: _ctx.val,
      onInput: _cache[1] || (_cache[1] = $event => _ctx.handleInput($event))
    }, null, 40, ["value"])
  ]))
})